import {GameBase} from "./GameBase";
import * as posedetection from "@tensorflow-models/pose-detection";
import {RecordManager} from "../common/RecordManager";

export class Jogging extends GameBase {
  constructor() {
    super()
    this.poseMode = posedetection.SupportedModels.BlazePose
    this.handMode = false

    this.preR = null
    this.preL = null

    this.distPerSecList = []
    this.preSec = null
    this.preTime = new Date().getTime()

    this.score = 0
    this.scoreDiff = 0
    this.lastSavedScore = 0
    this.time = 0
    this.timeSec = 0
    this.lastSavedtimeSec = 0
    this.speed = 0
    this.navigations = []
    this.legThreshold = 0.8

    this.poseToDist = 8

    this.lastSavedAt = null
  }

  mainLoop({ pose, hands }) {

  }

  saveData() {
    RecordManager.getInstance().addRecords(
      'jogging',
      {
        'time': this.timeSec - this.lastSavedtimeSec,
        'dist': this.score - this.lastSavedScore,
      }
    )
    this.lastSavedtimeSec = this.timeSec
    this.lastSavedScore = this.score
    this.lastSavedAt = new Date().getTime()
  }

  renderCamera(ctx, { pose, hands }) {
    if (!pose || !pose[0]) return

    const navigations = []
    const points = pose[0].keypoints3D
    if (points[26].score < this.legThreshold || points[25] < this.legThreshold) {
      const iconR = points[26].score < this.legThreshold ? 'warning' : 'check'
      const iconL = points[25].score < this.legThreshold ? 'warning' : 'check'
      navigations.push({icon:iconR,text:"右膝が映る位置"})
      navigations.push({icon:iconL,text:"左膝が映る位置"})
    }
    this.navigations = navigations
    if (this.navigations.length > 0) {
      this.speed = 0
      return
    }

    if (this.preR === null) {
      this.preR = points[26].y
      this.preL = points[25].y
    }
    const diffR = points[26].y - this.preR
    const diffL = points[25].y - this.preL
    const diff = Math.min(diffR, diffL)
    let score = 0
    if (diff < -0.001) {
      score = -this.poseToDist * diff
    }
    this.score += score
    this.scoreDiff = score

    const currentSec = new Date().getSeconds()
    if (this.preSec === null) this.preSec = currentSec
    if (currentSec !== this.preSec) {
      const distPerSec = this.distPerSecList.reduce((a, b) => a + b, 0)
      this.speed = ((distPerSec * 3600)/1000)
      this.preSec = currentSec
      this.distPerSecList = []
    }
    this.distPerSecList.push(score)
    this.preR = points[26].y
    this.preL = points[25].y

    const now = new Date().getTime()
    if (this.speed > 2.0) {
      this.time += (now - this.preTime)
    }
    const newTimeSec = Math.floor(this.time/1000)
    if (this.timeSec !== newTimeSec) {
      if (this.lastSavedAt === null || now - this.lastSavedAt > 3000) {
        this.saveData()
      }
      this.timeSec = newTimeSec
    }

    this.preTime = now
    // this.score += 1
  }
}



// WEBPACK FOOTER //
// ./src/components/game/Jogging.js